import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { Salutation } from '../../../../../@types/types'
import { useAppSelector } from '../../../../../app/hooks'
import { SCOUT_MANAGER } from '../../../../../config'

import styles from './ContactInfoListItemDetails.module.css'

export type ContactListItemDetailsProps = {
  hasBorder?: boolean
  selectedContactId?: number
}

const ContactInfoListItemDetails: React.FC<ContactListItemDetailsProps> = ({ selectedContactId, hasBorder = true }) => {
  const { t } = useTranslation()
  const contact = useAppSelector((state) =>
    state.contactFeature.contacts.find((contact) => contact.contactId === selectedContactId)
  )
  return (
    <div className={`${hasBorder ? 'border' : 'margin-top-l'} border-radius-rounded`}>
      <div
        className={`${hasBorder ? 'border-bottom' : 'margin-bottom-l'} font-body-medium-bold lap-padding desk-padding`}
      >
        <Trans i18nKey='wizard.screen.contactInfo.details.title'>Selected Contact Person</Trans>
        <a
          aria-label={t('wizard.screen.contactInfo.manager.editLabel')}
          className='padding-none link-text align-right float-right'
          target='_blank'
          rel='noopener noreferrer'
          href={SCOUT_MANAGER}
          style={{ color: 'black' }}
        >
          <i className='is24-icon-edit margin-right-xs' />
        </a>
      </div>
      <div className='lap-padding desk-padding'>
        <p className='font-body-medium-bold padding-bottom font-ellipsis'>
          {t(getSalutationTranslationkey(contact?.salutationType), '')} {contact?.firstName} {contact?.lastName}
        </p>

        <table className='one-whole'>
          <tbody>
            <RowSimple label={t('wizard.screen.contactInfo.details.email', 'Email')} value={contact?.email} />
            <RowSimple label={t('wizard.screen.contactInfo.details.phone', 'Phone')} value={contact?.phoneNumber} />
            <RowSimple
              label={t('wizard.screen.contactInfo.details.mobile', 'Mobile')}
              value={contact?.cellPhoneNumber}
            />
            <RowSimple label={t('wizard.screen.contactInfo.details.fax', 'Fax')} value={contact?.faxNumber} />
            <RowWithTwoEllipsis
              label={t('wizard.screen.contactInfo.details.address', 'Address')}
              value={contact?.address.street}
              value2={contact?.address.number}
            />
            <RowSimple label='' value={`${contact?.address.postcode ?? ''} ${contact?.address.city ?? ' '}`} />
          </tbody>
        </table>
      </div>
    </div>
  )
}
const RowSimple = ({ label, value }: { label: string; value?: string }) => (
  <tr className={styles.contactInfoDetailsRow}>
    <td className='padding-right'>
      {label}
      {label && ':'}
    </td>
    <td className={`align-right ${styles.ellipsisColumn}`}>
      <span className='font-ellipsis'>{value}</span>
    </td>
  </tr>
)

const RowWithTwoEllipsis = ({ label, value, value2 }: { label: string; value?: string; value2?: string }) => (
  <tr>
    <td className='padding-right'>
      {label}
      {label && ':'}
    </td>
    <td>
      <table className={styles.table}>
        <tbody>
          <tr>
            <td className={`${styles.ellipsisColumn} align-right padding-right-s`}>
              <span className='font-ellipsis'>{value}</span>
            </td>
            <td>{value2}</td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
)

function getSalutationTranslationkey(salutation?: Salutation) {
  if (salutation === Salutation.FEMALE) {
    return 'wizard.screen.contactInfo.salutation.female'
  } else if (salutation === Salutation.MALE) {
    return 'wizard.screen.contactInfo.salutation.male'
  }
  return 'wizard.screen.contactInfo.salutation.noInformation'
}

export default ContactInfoListItemDetails
